import { type DocumentType, graphql } from '@generated/gql';

export const WITHDRAWAL_BREAKDOWN_CALCULATE_WITHDRAW_FEES = graphql(
  /** GraphQL */ `
    query withdrawalBreakdownCalculateWithdrawFees(
      $input: CalculateWithdrawFeesInput!
    ) {
      calculateWithdrawFees(input: $input) {
        withdrawFees {
          type
          amountCents
        }
      }
    }
  `,
);

export type WithdrawalBreakdownFeesData = DocumentType<
  typeof WITHDRAWAL_BREAKDOWN_CALCULATE_WITHDRAW_FEES
>;
